import { useFeatureFlags } from 'feature-flags';

import { BOOKING_TYPE } from 'lib/constants';

/**
 * Teams flagged in Statsig (targeted by the `team_id` attribute) can't create Unmoderated or
 * Survey studies, even when their tracks settings otherwise allow it. It's a front-end block
 * only — every other product rule still follows the team's tracks settings.
 */
export const useIsSelfServeStudiesLocked = (): boolean => {
  const { lock_self_serve_studies } = useFeatureFlags(['lock_self_serve_studies']);

  return lock_self_serve_studies;
};

/**
 * Whether a given study is one the team is blocked from. Blocking the create menu isn't enough on
 * its own — a team can still reach an Unmoderated or Survey draft they already had, or duplicate
 * an old study — so submission is blocked too.
 */
export const useIsSelfServeStudyLocked = (studyType?: number | null): boolean => {
  const isLocked = useIsSelfServeStudiesLocked();

  return isLocked && (studyType === BOOKING_TYPE.UNMODERATED || studyType === BOOKING_TYPE.SURVEY);
};
